import {useEffect, useRef} from 'react';

import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import LayoutPage from 'layouts/LayoutPage/LayoutPage';
import {setNavigationTitleAC} from 'store/app/appSlice';

import ManageBeers from './ManageBeers/ManageBeers';
import './PostGenerator.scss';
import PostGeneratorHeader from './PostGeneratorHeader/PostGeneratorHeader';
import PostGeneratorSteps from './PostGeneratorSteps/PostGeneratorSteps';
import PostTemplate from './PostTemplate/PostTemplate';
import PostType from './PostType/PostType';
import {postGeneratorSteps} from './typescript';

export default function PostGenerator() {
  const dispatch = useSetGlobalState();
  const postRefs = useRef<HTMLDivElement[]>([]);
  const {step} = useGlobalState((state) => state.postGenerator);

  useEffect(() => {
    dispatch(setNavigationTitleAC('new post'));
    // eslint-disable-next-line
  }, []);

  return (
    <LayoutPage className="post-generator">
      <PostGeneratorHeader step={step} />
      <div className="post-generator__container">
        {step === postGeneratorSteps.manageBeers && <ManageBeers />}
        {step === postGeneratorSteps.postType && <PostType />}
        {step === postGeneratorSteps.postTemplate && <PostTemplate postRefs={postRefs} />}
      </div>
      <PostGeneratorSteps postRefs={postRefs} />
    </LayoutPage>
  );
}
